import { Outlet } from 'react-router-dom';

interface LayoutProps {
  appName: string;
  tagline: string;
}

export function Layout({ appName, tagline }: LayoutProps) {
  return (
    <div style={{ minHeight: '100vh', background: 'var(--bg)' }}>
      <div
        style={{
          maxWidth: '1080px',
          margin: '0 auto',
          padding:
            'calc(3.5rem + env(safe-area-inset-top)) calc(1.5rem + env(safe-area-inset-right)) calc(6rem + env(safe-area-inset-bottom)) calc(1.5rem + env(safe-area-inset-left))',
        }}
      >
        <header
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
            gap: '2rem',
            paddingBottom: '2.5rem',
            marginBottom: '3rem',
            borderBottom: '1px solid var(--border-hairline)',
          }}
        >
          <div>
            <h1
              style={{
                margin: 0,
                fontSize: 'clamp(2rem, 5vw, 3rem)',
                fontWeight: 400,
                letterSpacing: '-0.03em',
                lineHeight: 1.1,
              }}
            >
              {appName}
            </h1>
            <p
              style={{
                margin: '0.5rem 0 0',
                color: 'var(--text-secondary)',
                fontSize: 'var(--font-size-body)',
                maxWidth: '36ch',
              }}
            >
              {tagline}
            </p>
          </div>
        </header>
        <main>
          <Outlet />
        </main>
      </div>
    </div>
  );
}
